(() => {
  const init = (section) => {
    if (section.dataset.praReady === 'true') return;

    const productId = section.dataset.productId;
    const track = section.querySelector('[data-pra-reviews-track]');
    const openButton = section.querySelector('[data-pra-reviews-open]');
    const dialog = section.querySelector('[data-pra-reviews-dialog]');
    const nativeContainer = section.querySelector('[data-pra-reviews-native]');
    const averageNode = section.querySelector('[data-pra-reviews-average]');
    if (!track || !openButton || !dialog || !nativeContainer) return;

    if (!section.querySelector('.pra-product-reviews__arrow')) {
      const previous = document.createElement('button');
      previous.className = 'pra-product-reviews__arrow pra-product-reviews__arrow--previous';
      previous.type = 'button';
      previous.setAttribute('aria-label', 'Comentários anteriores');
      previous.textContent = '‹';
      const next = document.createElement('button');
      next.className = 'pra-product-reviews__arrow pra-product-reviews__arrow--next';
      next.type = 'button';
      next.setAttribute('aria-label', 'Próximos comentários');
      next.textContent = '›';
      previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }));
      section.append(previous, next);
    }

    const escapeHtml = (value = '') => {
      const node = document.createElement('div');
      node.textContent = value;
      return node.innerHTML;
    };

    const reviewImage = (review) => review.pictures_urls?.[0]?.original || review.pictures_urls?.[0]?.large || '';
    const stars = (score) => `${'★'.repeat(Math.round(score))}${'☆'.repeat(5 - Math.round(score))}`;

    const makeCard = (review) => {
      const card = document.createElement('article');
      card.className = 'pra-product-review-card';
      const image = reviewImage(review);
      const score = Number(review.rating || 5);
      card.innerHTML = `
        ${image ? `<img class="pra-product-review-card__image" src="${escapeHtml(image)}" alt="" loading="lazy">` : ''}
        <div class="pra-product-review-card__content">
          <span class="pra-product-review-card__verified"><img src="${window.praV2OkIconUrl || ''}" width="12" height="12" alt="">Verified Buyer</span>
          <span class="pra-product-review-card__author">${escapeHtml(review.reviewer_name || 'Cliente')}</span>
          <span class="pra-product-review-card__stars" aria-label="${score} de 5">${stars(score)}</span>
          <p>${escapeHtml(review.body || '')}</p>
        </div>`;
      return card;
    };

    let reviews = [];
    let page = 1;
    const perPage = 4;

    const renderModal = () => {
      const pages = Math.max(1, Math.ceil(reviews.length / perPage));
      page = Math.min(page, pages);
      const items = reviews.slice((page - 1) * perPage, page * perPage);
      nativeContainer.innerHTML = `
        <div class="pra-product-reviews__list">
          ${items.map((review) => {
            const score = Number(review.rating || 5);
            const image = reviewImage(review);
            const date = review.created_at ? new Intl.DateTimeFormat('pt-BR').format(new Date(review.created_at)) : '';
            return `<article class="pra-product-reviews__list-item">
              <span class="pra-product-review-card__verified"><img src="${window.praV2OkIconUrl || ''}" width="12" height="12" alt="">Verified Buyer</span>
              <div class="pra-product-reviews__meta"><span>${escapeHtml(review.reviewer_name || 'Cliente')}</span>${date ? `<span>Reviewed on ${date}</span>` : ''}</div>
              <span class="pra-product-review-card__stars" aria-label="${score} de 5">${stars(score)}</span>
              <p>${escapeHtml(review.body || '')}</p>
              ${image ? `<img class="pra-product-reviews__list-image" src="${escapeHtml(image)}" alt="" loading="lazy">` : ''}
            </article>`;
          }).join('')}
        </div>
        ${pages > 1 ? `<nav class="pra-product-reviews__pagination" aria-label="Paginação">
          <button type="button" data-page="${page - 1}" ${page === 1 ? 'disabled' : ''}>←</button>
          ${Array.from({ length: pages }, (_, index) => index + 1).map((number) => `<button type="button" data-page="${number}" class="${number === page ? 'is-active' : ''}">${number}</button>`).join('')}
          <button type="button" data-page="${page + 1}" ${page === pages ? 'disabled' : ''}>→</button>
        </nav>` : ''}`;
      nativeContainer.querySelectorAll('[data-page]').forEach((button) => button.addEventListener('click', () => {
        page = Number(button.dataset.page);
        renderModal();
        nativeContainer.scrollTop = 0;
      }));
    };

    const render = () => {
      const data = window.jdgm?.data?.reviewWidget?.[productId];
      reviews = data?.reviews || [];
      if (!reviews.length) return false;
      const average = Number(data.average_rating || 5).toFixed(1);
      if (averageNode) averageNode.textContent = average;
      const dialogSummary = section.querySelector('[data-pra-dialog-summary]');
      if (dialogSummary) dialogSummary.innerHTML = `<span aria-hidden="true">★★★★★</span><strong>${average}</strong><small>/5</small>`;
      track.replaceChildren(...reviews.slice(0, 6).map(makeCard));
      renderModal();
      openButton.hidden = false;
      section.classList.add('is-ready');
      section.dataset.praReady = 'true';
      document.querySelectorAll('.shopify-section .jdgm-review-widget').forEach((widget) => {
        const wrapper = widget.closest('.shopify-section');
        if (wrapper && !section.contains(wrapper)) wrapper.hidden = true;
      });
      return true;
    };

    openButton.addEventListener('click', () => {
      nativeContainer.scrollTop = 0;
      dialog.showModal();
      document.documentElement.classList.add('overflow-hidden');
    });
    section.querySelector('[data-pra-reviews-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => document.documentElement.classList.remove('overflow-hidden'));

    if (!render()) {
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (render() || attempts >= 40) window.clearInterval(timer);
      }, 250);
    }
  };

  const boot = () => document.querySelectorAll('[data-pra-product-reviews]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
